import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Outlet } from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";
import WhatsappIcon from "../assets/media/whatsapp.d026940870fb334920b7.png";

const Layout = () => {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Outlet />
      <Footer />

      <div className="custom-whatsapp-contact">
        <a
          href="https://wa.me/917011858174"
          target="_blank"
          rel="noopener noreferrer"
          className=""
        >
          <img src={WhatsappIcon} alt="" className="img-fluid m-0" />
        </a>
      </div>
    </>
  );
};

export default Layout;
